module.exports = __webpack_public_path__ + "img/isae3000_t2.ff562ebf.png";